import { render, staticRenderFns } from "./PayTypeSelect.vue?vue&type=template&id=5c83ba31&scoped=true&"
import script from "./PayTypeSelect.vue?vue&type=script&lang=js&"
export * from "./PayTypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./PayTypeSelect.vue?vue&type=style&index=0&id=5c83ba31&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83ba31",
  null
  
)

export default component.exports